import { render, staticRenderFns } from "./novatabelaprecoexcel.vue?vue&type=template&id=cfb7aed4&"
import script from "./novatabelaprecoexcel.vue?vue&type=script&lang=js&"
export * from "./novatabelaprecoexcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports